export default {
	data() {
		return {
			x: 0,
			y: 0
		}
	},
	computed: {
		position() {
			return {
				transform: `translate3d(${this.x}px, ${this.y}px, 0)`
			}
		}
	},
	methods: {
		moveTo([x, y]) {
			this.x = x
			this.y = y
		}
	}
}
